export const theme = {
    colors: {
      primary: '#ffd33d',
      text: '#fff',
      titleText: '#ffd33d',
      navText: '#000',
      background: '#25292e',
      error: '#ff6b6b',
      success: '#28a745',
      secondary: '#eeeeee',
      ufiGreen: '#009688',
      ufiGreenLight: '#badfdb',
    },
    spacing: {
      small: '10px',
      medium: '20px',
      large: '30px',
    },
    borderRadius: '5px',
    maxWidth: '800px',
  };